import React from 'react';
import { StyledDivider } from './divider.styled';

function Divider(props) {
  return <StyledDivider {...props} />;
}

export default Divider;
